/* batida-pdp-ready.js — FIX Batida V.5.3.5 (Path A reveal, 2026-05-29;
   orphan-napis guard removed by BS-1, 2026-05-30).

   REVEAL the cloaked lower info column (hidden by batida-pdp-cls.css until
   .batida-pdp-ready) once custom.js has finished rebuilding it — so the
   shopper sees the finished column fade in, never the raw "Dołącz X + PRICE"
   upsell markup or the stacked-then-snapping qty/ATC.
     - Wait for the qty/ATC row (.batida-qty-atc-row) — built on every PDP.
     - If the product has legacy cross-sell items (.cross-products), also wait
       for .batida-perso-card so the raw cross-sell markup never flashes.
     - Hard 2s fallback always reveals.

   (BS-1 removed the orphan-napis guard that used to live here. The stray
   inscription field is now prevented at the source — product-buttons.liquid
   renders the .litem slot only for cake-text products — so no orphan exists.) */
(function () {
  if (!document.querySelector('body.template-product')) return;

  var done = false;
  var settleTimer = null;
  function reveal() {
    if (done) return;
    done = true;
    document.documentElement.classList.add('batida-pdp-ready');
  }
  // BS-15 (2026-05-30): reveal the cloaked column only once the buy-box is fully ASSEMBLED and
  // STABLE, so it fades in finished — no ATC resize (387->275 was the qty appearing at reveal),
  // no qty/card flash.
  //  - Require qty to be a DIRECT child of .batida-qty-atc-row. custom.js builds the row and
  //    ensureQtyInWrapper() settles qty beside the ATC, but a one-shot DOMContentLoaded mover
  //    transiently yanks qty into the buttons form. The direct-child combinator (>) only matches
  //    the settled position, not the transient nested one.
  //  - Require it to STAY settled for 200ms before revealing, so that one-shot mover can't fire
  //    AFTER we reveal (any move clears the timer; the MutationObserver below re-arms it). Robust
  //    regardless of custom.js vs this-file load order. The whole assembly is hidden by the
  //    opacity cloak (batida-pdp-cls.css) until we add .batida-pdp-ready.
  //  - Still wait for the Personalizacja card when the product has cross-sell items.
  function check() {
    if (done) return true;
    if (!document.querySelector('.batida-qty-atc-row > .product__block__quantity')) {
      if (settleTimer) { clearTimeout(settleTimer); settleTimer = null; }
      return false;
    }
    if (document.querySelector('.cross-products .cross-product') &&
        !document.querySelector('.batida-perso-card')) return false;
    if (!settleTimer) {
      settleTimer = setTimeout(function () {
        if (document.querySelector('.batida-qty-atc-row > .product__block__quantity')) reveal();
      }, 200);
    }
    return false;
  }

  /* ---------- run ---------- */
  if (!check()) {
    try {
      var mo = new MutationObserver(function () { if (check()) mo.disconnect(); });
      mo.observe(document.documentElement, { childList: true, subtree: true });
      setTimeout(function () { try { mo.disconnect(); } catch (e) {} }, 3000);
    } catch (e) {}
    setTimeout(reveal, 2000); // hard fallback — always reveal
  }
})();
